export const colors = {
   // Generate a unique color from a given string
   // https://stackoverflow.com/questions/3426404/create-a-hexadecimal-colour-based-on-a-string-with-javascript

    getColor: (str) => {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var colour = '#';
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
      }
      return colour;
    }
}

export const time = {
  // Compares a date and now, and checks if the result is bigger than the given minutes
  isAfter: (date, minutes) => {
    // compare last login time to current time
    let lastLogin = new Date(date);
    let currentTime = new Date();
    let diff = currentTime - lastLogin; // difference in milliseconds

    let mins = Math.floor(diff / 60000); 
    // if the difference is greater than 30 minutes, remove the deliveryman
    if (mins > minutes) {
      return false;
    } else {
      return true;
    }
  }
}